import { LabelM } from '@components/base-typography'
import { TextButton } from '@components/base-button/text-button'
import { colors } from '@styles/colors'
import { IconType } from '../icon'
import { BaseBlock } from '@components/base-block'

interface EmptyListProps {
  leading?: IconType
  trailing?: IconType
  onClick?: () => void
  title: string
  buttonLabel?: string
  padding?: string
  isFilterSelected?: boolean
  backgoundColor?: string
}

export const EmptyList = ({
  leading,
  trailing,
  onClick,
  title,
  buttonLabel,
  isFilterSelected,
  backgoundColor,
  padding = '120px',
}: EmptyListProps) => (
  <BaseBlock
    flexbox
    flexCenter
    column
    paddingTop={padding}
    paddingBottom={padding}
    width="100%"
    backgroundColor={backgoundColor}
    rounded={16}
  >
    <LabelM color={colors.gray500}>{title}</LabelM>
    {isFilterSelected && (
      <TextButton
        onClick={onClick}
        color={colors.blue400}
        leading={leading}
        trailing={trailing}
        spaceTop={12}
      >
        {buttonLabel}
      </TextButton>
    )}
  </BaseBlock>
)
